const initialState = {
        sidebar: true
};

export default initialState;